module.exports = __webpack_public_path__ + "static/img/qcx-a4.493afd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qcx-a4.png
// module id = +Tqa
// module chunks = 1